<script lang="ts">
    // Show a form based on the session status or a "routing" status.
    import { onDestroy } from 'svelte'

    import { lg } from 'hydria/services/language'
    import { newSignin, session, signedIn, user } from 'hydria/services/session'

    import { params, signinBlockPage } from './globalContext'
    import { default as LostPassword } from './LostPassword.svelte'
    import { default as SetPassword } from './SetPassword.svelte'
    import SignedOutModal from './SignedOutModal.svelte'
    import { default as Signin } from './Signin.svelte'

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    // Will be null ( -> 'signin'), or 'request', or 'auto-signin'
    const initialBlockPage = $signinBlockPage

    let showSignedoutAlert: 'normal' | 'delegate' | undefined = $state(undefined)
    $effect(() => {
        if (showSignedoutAlert && !document.documentElement.classList.contains('modal-open')) {
            document.documentElement.classList.add('modal-open')
        } else if (!showSignedoutAlert && document.documentElement.classList.contains('modal-open')) {
            document.documentElement.classList.remove('modal-open')
        }
    })

    if ((initialBlockPage === 'signin' || initialBlockPage == null) && window.location.search.startsWith('?signed-out')) {
        // We just signed out, or the session expired.
        // In any case, we were redirected from the client site.

        showSignedoutAlert = window.location.search === '?signed-out=was-deleg' ? 'delegate' : 'normal'
        history.replaceState(null, '', `/${$lg}/`)
    }

    if (initialBlockPage == 'auto-signin') {
        session.tokenSignin($params['signin-token'])
    } else {
        unsubs.push(
            signedIn.subscribe((nv) => {
                // if (initialBlockPage == 'signin' && nv) {
                //     console.log('Signed in, entering client area')
                //     window.location.assign('/client/')
                // } else
                if (initialBlockPage === 'set-password') {
                    // NOP
                    // signinBlockPage = initialBlockPage
                } else {
                    signinBlockPage.set(nv ? 'welcome' : 'signin')
                }
            }),
        )
    }
    unsubs.push(
        newSignin.subscribe((nv) => {
            if (nv) {
                console.info('Signed in, entering client area')
                $signinBlockPage = 'signin-in'
                window.location.assign('/client/')
            }
        }),
    )

    function goto(where: 'signin-in' | 'welcome' | 'signin' | 'lost-password' | 'register') {
        if (['lost-password', 'register'].includes(where)) {
            $signinBlockPage = where
        } else {
            if ($newSignin) {
                $signinBlockPage = 'signin-in'
            } else {
                $signinBlockPage = $signedIn ? 'welcome' : 'signin'
            }
        }
    }
</script>

<div id="signin-form" class={`signin-sub-${$signinBlockPage}`}>
    <div>
        {#if $signinBlockPage == 'welcome'}
            {#if $lg == 'fr'}
                {#if $user && $user.name}
                    <p>Bonjour, {$user.name} !</p>
                {:else}
                    <p>Bienvenue !</p>
                {/if}
                <p class="mb-0"><a href="/client/">Entrer dans l’espace client</a></p>
            {:else}
                {#if $user && $user.name}
                    <p>Hello, {$user.name}!</p>
                {:else}
                    <p>Welcome!</p>
                {/if}
                <p><a href="/client/">Go to the client area</a></p>
            {/if}
            <p class="mb-0">
                <a
                    href="/{$lg}/"
                    onclick={(event) => {
                        event.preventDefault()
                        session.signout()
                    }}>{$lg == 'fr' ? 'Quitter' : 'Sign out'}</a
                >
            </p>
        {:else if 'signin' == $signinBlockPage}
            <Signin {goto} canAutofocus={showSignedoutAlert == null} />
        {:else if ['lost-password', 'register'].includes($signinBlockPage)}
            <LostPassword {goto} />
        {:else if $signinBlockPage == 'set-password'}
            <SetPassword />
        {:else}
            <p class="text-center">
                {#if $lg == 'fr'}Un moment…
                {:else}Please wait…
                {/if}
            </p>
        {/if}
    </div>
</div>
{#if showSignedoutAlert}
    <SignedOutModal wasDeleg={showSignedoutAlert == 'delegate'} onclose={() => (showSignedoutAlert = undefined)} />
{/if}
